export default "__VITE_ASSET__CyVJ9Tiv__"